import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { KeycloakService } from '../security/keycloak.service';
import { RolesDialogComponent } from './roles-dialog';

@Component({
  standalone: true,
  selector: 'app-profile-menu',
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatDialogModule,
  ],
  styles: [`
    .profile-btn { font-weight: 600; color: #e5e7eb; background-color: #38bdf8}
    .menu-header { padding: 12px 16px 8px 16px; min-width: 240px; }
    .hello { font-size: 12px; opacity: .75; }
    .username { font-size: 14px; font-weight: 600; margin-top: 2px; }
  `],
  template: `
    <button mat-button class="profile-btn" [matMenuTriggerFor]="profileMenu">
      Profile <mat-icon>expand_more</mat-icon>
    </button>

    <mat-menu #profileMenu="matMenu" xPosition="before" yPosition="below">
      <div class="menu-header" (click)="$event.stopPropagation()">
        <div class="hello">Hello,</div>
        <div class="username">{{ username() }}</div>
      </div>

      <mat-divider></mat-divider>

      <button mat-menu-item (click)="openRoles()">
        <mat-icon>verified_user</mat-icon>
        <span>Roles</span>
      </button>

      <mat-divider></mat-divider>

      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  `,
})
export class ProfileMenuComponent {
  username = signal('');

  // If your roles are in a different client than the SPA, set it here:
  // e.g. ['vigimare-api'] or ['vigimare-web', 'vigimare-api']
  //private roleClients = ['vigimare-web'];

  constructor(private dialog: MatDialog,private keycloakService: KeycloakService) {
    this.username.set(this.keycloakService.getUsername());
  }

  openRoles() {
    const roles = this.keycloakService.getAllRoles();
    this.dialog.open(RolesDialogComponent, {
      data: { roles },
      width: '360px',
    });
  }

  logout() {
    this.keycloakService.logout();
  }
}
